import React, { useCallback, useContext, useEffect, useRef, useState, memo } from 'react'
import Card from '../component/Card';
import { data, useParams } from 'react-router-dom';
import * as mediasoupClient from 'mediasoup-client';
import io from 'socket.io-client';
import Message from '../component/Message';
import { Modal, Button, Alert, Offcanvas } from 'react-bootstrap'
import PointTracker from '../component/PointTracker';
import {UserContext} from '../context/UserContext'
import {callAPI} from '../helper/apiHelper'
import {BASE_URL, API_URL_ENDPOINT, SOCKET_URL} from '../appsetting/appsetting'
import PageLoader from '../component/PageLoader';
import { ToastContainer, toast } from 'react-toastify';
let audioProducerTransport;
let audioConsumerTransport;

let toastOption = {
  position: "top-center",
  autoClose: 2000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
}


const Home = memo(() => {

    const { globalUser, updateUser,  login } = useContext(UserContext);
    const [room, setRoom] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [chat, setChat] = useState([])
    const [requests, setRequests] = useState([]);
    const [liveMembers, setLiveMembers] = useState([]);
    const [message, setMessage] = useState('');
    const [totalParticipats, setTotalParticipate] = useState(0);
    const [showParticipate, setShowParticipate] = useState(false)
    const socket = useRef(null);
    const device = useRef(null);
    const chatBoxRef = useRef(null);
    
    const { id } = useParams();
    const [audiostreams, setAudioStreams] = useState(Array(6).fill(null));
    
    const audioTrack = useRef(null);
  
    useEffect(() => {
      const usertoken = id.split('::')[1];
      const roomID = id.split('::')[0];
      FindRoomByID(roomID)
      FindUserByToken(usertoken, roomID);
      socket.current = io(BASE_URL);
      const {audTrack, stream } = getLocalVideo();
    
      return () => {
        if (socket.current) {
          socket.current.disconnect();
        }
      };
    }, []);

    useEffect(()=>{
      if(!Array.isArray(audiostreams)){
        setAudioStreams(Array(6).fill(null));
      }
    },[audiostreams])

    useEffect(() => {
      // Define the global function to receive messages
      window.receiveMessageFromReactNative = (message) => {
        console.log("Message from React Native:", message);
        handleEndCall(globalUser?.isHost,"")
        // Handle the message as needed
      };
    }, []);

    useEffect(() => {
      if(globalUser && room){
        // console.log("Room Detail", room)
        socket.current.emit('joinRoom', {roomId : room?.RoomID, userID : globalUser.ID});
        startApp(globalUser);
        setTimeout(() => {
          room?.seat.map((obj, index) => {
            if (obj.ProducerID && obj.UserID !== globalUser.ID) {
              ConsumeAudioTracks(obj.ProducerID, globalUser.ID);
            }

            if (obj.UserID === globalUser.ID) {
              StartProducing();
            }
          
            return null;
          });
        },500);

        if(globalUser?.isHost){
          getSeatReuest()
        }

        //Consume Producer Streams
        socket.current.on('NewProducerJoined', handleNewProducerJoined)
        socket.current.on('ProducerDisconnect', handleProducerDisconnect)
        socket.current.on('ConsumerDisconnect', handleConsumerDisconnect)
        socket.current.on('user-connected', handleNewUserConnect)

        socket.current.on('LiveMessageReceived', handleLiveMessageRecived)
        socket.current.on('MicStatusChanged', handleMicStatusChanged)
        socket.current.on('seatRequestReceived', handleRequestReceived)
        socket.current.on('RequestAccepted', handleRequestAccepted)
        socket.current.on('MettingEnd', handleEndMetting)

      }
      return () => {
        socket.current.off('NewProducerJoined');
        socket.current.off('ProducerDisconnect');
        socket.current.off('ConsumerDisconnect');
        socket.current.off('LiveMessageReceived');
        socket.current.off('MicStatusChanged');
        socket.current.off('seatRequestReceived');
        socket.current.off('RequestAccepted');
        socket.current.off('MettingEnd');
      };
    }, [globalUser, room, socket.current]);
  
    useEffect(() => {
      if (chatBoxRef.current) {
        chatBoxRef.current.scrollTo({
          top: chatBoxRef.current.scrollHeight,
          behavior: 'smooth', 
        });
      }
    }, [chat]);

    const handleLiveMessageRecived = (data) =>{
      setChat((prevChat) => [...prevChat, data]);
    }

    const handleEndMetting = () => {
      setAudioStreams(Array(6).fill(null));
      setRoom(null);
      setErrorMessage("Metting End By Host")
    }

    const handleMicStatusChanged = async(data) =>{
  
      // console.log("Mic Change From Socket", audioTrack.current)
      const {userid, status} = data;
      setAudioStreams((prevStreams) => {
        const updatedObject = prevStreams?.find(sobj => sobj?.userID === userid);
        if (updatedObject) 
        {
          updatedObject.isMicOn = status;
          const updatedStreams = [...prevStreams];
          const index = updatedObject.seatNo - 1; 
          updatedStreams[index] = updatedObject; 
          return updatedStreams;
        }
      });

      if(userid == globalUser?.ID && audioTrack.current){
        audioTrack.current.enabled = status;
        console.log("Audio Track Chnaged By Host", audioTrack.current.enabled)
      }
      
    }

    const handleNewProducerJoined = (data) => {
      const { producerID } = data;
      ConsumeAudioTracks(producerID, globalUser.ID);
      console.log("New Producer  Joined", producerID);
    };

    const handleProducerDisconnect = (data) => {
      const {userid} = data;
      removeFromSeat(userid)
      console.log("User Removed Me")
    }

    const handleConsumerDisconnect = (data) => {
      console.log("Recived")
      if(globalUser?.isHost){
        console.log("Recived1")
        getSeatReuest();
      }
    }

    const removeFromSeat = (userid) => {
      
      setAudioStreams((prevStreams) => {
        const updatedObject = prevStreams?.find(sobj => sobj?.userID === userid);
        if (updatedObject) 
        {
          const updatedStreams = [...prevStreams];
          const index = updatedObject.seatNo - 1; 
          updatedStreams[index] = null; 
          return updatedStreams;
        }
      });
      if(userid === globalUser?.ID){
        updateUser({ SeatRequest: false })
        const updatedSeatData = { UserID: 0, SeatNo: null, ProducerID: null };
        const updatedRoom = updateRoomSeatByUserId(room, userid, updatedSeatData);
        setRoom(updatedRoom);
      }
    }

    const handleNewUserConnect = (data) =>{
      const {totalParticipate} = data;
      setTotalParticipate(totalParticipate);
    }

    const handleRequestReceived = () =>{
      if(globalUser?.isHost){
        getSeatReuest();
      }
    }

    const updateSeatInRoom = (room, seatNo, updatedSeatData) => {
      return {
        ...room,
        seat: room.seat.map(seat =>
          seat.SeatNo === seatNo ? { ...seat, ...updatedSeatData } : seat
        ),
      };
    };

    const updateRoomSeatByUserId = (room, userid, updatedSeatData) => {
      return {
        ...room,
        seat: room.seat.map(seat =>
          seat.UserID === userid ? { ...seat, ...updatedSeatData } : seat
        ),
      };
    }

    const handleRequestAccepted = (data) => {
      const {userID, seatNo, action} = data;
      if(globalUser?.ID == userID && action){
        const updatedSeatData = { UserID: userID, SeatNo: seatNo, ProducerID: null };
        const updatedRoom = updateSeatInRoom(room, seatNo, updatedSeatData);
        setRoom(updatedRoom);
        toast.success("Your Seat Request Accepted",toastOption)
        StartProducing()
      }else if(globalUser?.ID == userID && !action){
        toast.error("Your Seat Request Rejected",toastOption)
        updateUser({ SeatRequest: false })
      }
      if(globalUser?.isHost){
        getSeatReuest();
      }
    }
  
    useEffect(() => {
      return () => {
        audiostreams.forEach(streamObj => {
          streamObj?.stream.getTracks().forEach(track => track.stop());
        });
        setAudioStreams(Array(6).fill(null));
      };
    }, []);

    const sendMessage = () => {
      if (message.trim() !== '') {
        const data = {
          FullName:globalUser.FullName,
          Content:message
        }
        setChat((prevChat) => [...prevChat, data]);
        setMessage(''); 
        socket.current.emit('sendLiveMessage',data)
      }
    };

    const addOrUpdateStream = (streamObj) => {
      setAudioStreams((prevStreams) => {
        if (!Array.isArray(prevStreams)) {
          console.error("prevStreams is not an array:", prevStreams);
          return []; // or handle the issue as needed
        }
        const updatedStreams = [...prevStreams];
        const index = streamObj.seatNo - 1;
        updatedStreams[index] = streamObj;
        return updatedStreams;
      });
    };

    const clearStream = (seatNo) => {
      setAudioStreams((prevStreams) => {
        const updatedStreams = [...prevStreams];
        updatedStreams[seatNo - 1] = null; 
        return updatedStreams;
      });
    };

    const handleGoToHome = () => {
      window.ReactNativeWebView?.postMessage("END_CALL");
    }

    const handleEndCall = (isHost, action) =>{
      if(isHost && action == ""){
        setShowConfirm(true);
        return;
      }
      if(isHost && action === "END_METTING"){
        socket.current.emit("MettingEnd", ({roomID:room?.roomID}))
        setRoom(null)
        if(showConfirm){
          setShowConfirm(false)
        }
        setErrorMessage("Metting Ended.")
        return;
      }

      const canProduce = room.seat.some(seatobj => seatobj.UserID === globalUser?.ID);
      if(canProduce){
        setAudioStreams((prevStreams) => {
          const updatedObject = prevStreams?.find(sobj => sobj?.userID === globalUser?.ID);
          if (updatedObject) 
          {
            const updatedStreams = [...prevStreams];
            const index = updatedObject.seatNo - 1; 
            updatedStreams[index] = null; 
            return updatedStreams;
          }
        });
        socket.current.emit("ProducerDisconnected", ({userID:globalUser?.ID}))
      }
      setRoom(null)
      if(showConfirm){
        setShowConfirm(false)
      }
      setErrorMessage("Call Ended.")
      window.ReactNativeWebView?.postMessage("END_CALL");
    }
    

    const FindUserByToken = async (userToken, roomID) =>{
      try{
        setLoading(true);
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.FIND_USER_BY_TOKEN + `?token=${userToken}&room=${roomID}`);
        if(response?.data && response?.status){
          login(response.data)
        } else {
          throw new Error(response?.message  || 'No User Found')
        }
      }catch(error){
        setErrorMessage(error.message)
      }finally{
        setLoading(false);
      }
    }

    const FindRoomByID = async (roomToken) =>{
      try{
        setLoading(true);
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.FIND_ROOM_BY_ID + `?roomID=${roomToken}`);
        if(response?.data && response?.status){
          setRoom(response.data)
          setTotalParticipate(response.data.TotalParticipate);
        }else{
          throw new Error(response?.message || "Invalid Room")
        }
      }catch(error){
        setErrorMessage(error.message)
      }finally{
        setLoading(false);
      }
    }

    const getSeatReuest = async () =>{
      try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.SEAT_REQUEST_LIST + `?roomID=${room?.RoomID}`);
        if(response?.data && response?.status){
          setRequests(response.data)
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setRequests([])
      }finally{
      }
    }

    const acceptRequest = async (requestID, userID, action) =>{
      //on Accept
      let seatNo = null;
      if(action){
        for (let i = 0; i < audiostreams.length; i++) {
          if (audiostreams[i] === null) {
              seatNo = i + 1;
          }
        }
        if(seatNo == null){
          seatNo = Math.floor(Math.random() * (6 - 2 + 1)) + 2;
        }
        await handleRequestAction(requestID, userID, action, seatNo)
      }
    }

    const handleShowParticipate = async () => {
      try{
        setLoading(true);
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_LIVE_MEMBERS + "?roomID="+room?.RoomID);
        if(response?.status){
          setLiveMembers(response.data)
          setShowParticipate(true)
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setShowParticipate(false)
        setLiveMembers([])
      }finally{
        setLoading(false)
      }
    }

    const handleRequestAction = async (requestID, userID, action, seatNo = null) =>{
      try{
        const options = {
          method: 'POST',
          data: {
            userId: userID,
            requestID: requestID,
            roomID : room?.RoomID,
            action : action,
            seatNo : seatNo
          },
        }

        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.ACTION_ON_REQUEST, options);
        if(response?.status){
          getSeatReuest()
          setShow(false)
          toast.success(response?.message,toastOption)

          const data = {
            userID,
            seatNo,
            action
          }
          socket.current.emit('RequestAccepted',data);
          
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setShow(false)
        setRequests([])
        toast.error(error?.message || "Something Went Wrong.",toastOption)
      }finally{
        
      }
    }
  
    const startApp = async (user) => {
      try{
        const rtpCapabilities = await new Promise(resolve => {
          socket.current.emit('getRouterRtpCapabilities', resolve);
        });

        device.current = new mediasoupClient.Device();
        await device.current.load({routerRtpCapabilities : rtpCapabilities });
    
    
        const audioProducerTransportOptions = await new Promise(resolve => {
          socket.current.emit('createAudioProducerTransport',{ userID : user.ID}, resolve);
        });
    
        audioProducerTransport = device.current.createSendTransport(audioProducerTransportOptions);
        audioProducerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
          socket.current.emit('connectAudioProducerTransport', { userID : user.ID, dtlsParameters }, callback);
          callback();
        });
    
        audioProducerTransport.on('produce', async ({ kind, rtpParameters }, callback) => {
          const userSeat = room?.seat.filter(seat => seat.UserID === globalUser?.ID)[0]?.SeatNo;
          socket.current.emit('produceAudio', {userID : user.ID, isHost : globalUser?.isHost, userSeat, kind, rtpParameters }, response => {
            // console.log("ProducerAudioRTP", rtpParameters)
            callback({ producerId: response.id });
          });
        });
    

        const consumerAudioTransportOptions = await new Promise(resolve => {
          socket.current.emit('createConsumerAudioTransport', {userID : user.ID}, resolve);
        });

        audioConsumerTransport = device.current.createRecvTransport(consumerAudioTransportOptions);
        audioConsumerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
          socket.current.emit('connectConsumerAudioTransport', {userID : user.ID, dtlsParameters }, callback);
          callback();
        });
    
      }catch(error){
        console.error('Error in startApp:', error);
      }
    };
  
    const getLocalVideo = async () => {  
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      let audTrack;
      stream.getTracks().forEach(track => {
        if (track.kind === 'audio') audTrack = track;
      })
      audioTrack.current = audTrack;
      audioTrack.current.enabled = false;
      return {audTrack, stream };
    };

    const StartProducing = useCallback(async (seatNo)=>{
      if(room){
        const canProduce = room.seat.some(seatobj => seatobj.UserID === globalUser?.ID);
        if(canProduce){
          await audioProducerTransport.produce({
            codecOptions: {
              opusStereo: true, 
              opusDtx: true,    
              audioGoogleNoiseSuppression: true,
              audioGoogleAutomaticGainControl: true,
              audioGoogleEchoCancellation: true
            },
            track: audioTrack.current
          })

          const foundUser = room?.seat.find(seat => seat.UserID === globalUser?.ID);
          const sobj = {
            stream: null,
            producerName: globalUser?.FullName,
            profile: globalUser?.ProfilePhoto,
            producerId: null,
            seatNo: foundUser.SeatNo,
            isHost: globalUser?.isHost,
            userID: globalUser?.ID, 
            isMicOn : false,
          };
          addOrUpdateStream(sobj)
        }else{
          console.log("Can Not Produce")
        }
      }
    },[room, globalUser])
  
    const ConsumeAudioTracks = useCallback(async (producerID, userID) => {
      try {
        const consumeAudio = await new Promise((resolve) => {
          // console.log("Second Call")
          const rtpCapabilities = device.current.rtpCapabilities;
          socket.current.emit('consumeAudio', { userID, rtpCapabilities, producerID }, resolve);
        });
    
        if (consumeAudio.error) {
          console.error("Cannot consume Audio:", userID , consumeAudio.error);
          return;
        }
        console.log("Consumer", userID)
    
        const consumer = await audioConsumerTransport.consume({
          id: consumeAudio.id,
          producerId: consumeAudio.producerId,
          kind: consumeAudio.kind,
          rtpParameters: consumeAudio.rtpParameters,
        });
    
        const { track } = consumer;
        const remoteStream = new MediaStream([track]);
        
    
        const sobj = {
          stream: remoteStream,
          producerName: consumeAudio?.FullName,
          profile: consumeAudio?.Profile,
          producerId: consumeAudio?.producerId,
          seatNo: consumeAudio?.SeatNo,
          isHost: consumeAudio?.isHost,
          userID : consumeAudio?.userID,
          isMicOn : consumeAudio?.isMicOn,
        };
        
        addOrUpdateStream(sobj);
  
      } catch (error) {
        console.error("Error in ConsumeTracks:", error);
      }
    },[device.current])
    

    const sendSeatRequest = async () => {
      try{
        const options = {
          method: 'POST',
          data: {
            userId: globalUser?.ID,
            roomID: room?.RoomID,
          },
        }
        const response = await callAPI(BASE_URL+API_URL_ENDPOINT.SEND_SEAT_REQUEST, options)

        if(response?.status){
          toast.success(response?.message,toastOption)
          updateUser({ SeatRequest: true })
          socket.current.emit("seatRequestSend")
        } else {
          throw new Error(response?.message  || 'Failed To Send Request.')
        }
      }catch(error){
        toast.error(error?.message || "Something Went Wrong.",toastOption)
        updateUser({ SeatRequest: false })
      }
    }

    const toggleMic = (userid) =>{
      if(userid === globalUser?.ID || globalUser.isHost){
        const updatedObject = audiostreams.find(sobj => sobj?.userID === userid);
        if (updatedObject) 
        {
          const currentStatus = updatedObject.isMicOn;
          if(!currentStatus && globalUser.isHost && userid != globalUser?.ID){
            toast.error("You Can Not On Other's Mic",toastOption)
            return;
          }
          updatedObject.isMicOn = !updatedObject.isMicOn;
          addOrUpdateStream(updatedObject)
        }
        if(userid === globalUser?.ID && audioTrack.current){
            // console.log("Audio Track")
            audioTrack.current.enabled = updatedObject.isMicOn;
        }
        const data = {
          userid,
          status : updatedObject.isMicOn
        }
        socket.current.emit('MicStatusChanged', (data))
      }
    }

    const handleLeaveSeat = (userid) =>{
      removeFromSeat(userid)      
      socket.current.emit('ProducerDisconnected', ({userid}))
    }


    const handleMessageChange = (e) => setMessage(e.target.value);
    return (
    <>
      <PageLoader show={loading} />
      {(globalUser && room) ?
        <div style={{height:'100vh', background:'#474338'}} className='d-flex flex-column'>
          {console.log("Whole Card Re-render")}
          <marquee className='bg-white m-2 rounded-pill text-danger fw-bold'>{room?.LiveTitle}</marquee>
          <div className='container-fluid'>
              <div className='d-flex justify-content-between mb-3'>
                  <div onClick={handleShowParticipate} style={{cursor:'pointer'}} className='rounded-pill bg-warning d-flex justify-content-center align-items-center'>
                      <div className='mx-2' style={{fontSize:12}}><i className="bi bi-people-fill"></i> {totalParticipats} Members</div>
                  </div>
                  <PointTracker/>
                  {/* <div style={{fontSize:12}} className=' fw-bold text-warning'>Point Win : 0</div> */}
              </div>
              <div className='row'>
                {
                  audiostreams?.map((streamObj, index) => (
                    <div key={index} className='col-4'>
                        <Card obj={streamObj} isEmpty={(streamObj)? false : true} toggleMic={toggleMic} leaveSeat={handleLeaveSeat}/>
                    </div>
                  ))
                }
              </div>
              <div className='d-flex justify-content-between mb-2 align-items-center'>
              {(globalUser?.isHost)?<button style={{fontSize:12}} onClick={()=>setShow(true)} className='rounded-pill bg-success text-white d-flex justify-content-center align-items-center btn btn-sm shadow-none'>Seat Requests {requests.length>0 ? <div className='rounded-circle bg-white text-dark ms-2 px-1'>{requests.length.toString().padStart(2, '0')}</div> : ''}</button> : <button onClick={sendSeatRequest} style={{fontSize:12}} disabled={globalUser?.SeatRequest} className='rounded-pill bg-info d-flex justify-content-center align-items-center btn btn-sm shadow-none'><i className="bi bi-universal-access-circle me-1"></i> Request Seat</button>}
                  <button onClick={()=>handleEndCall(globalUser?.isHost,"")} style={{fontSize:12}} className='rounded-pill bg-danger text-white d-flex justify-content-center align-items-center btn btn-sm shadow-none'><i className="bi bi-telephone-fill me-1"></i> End Call</button>
              </div>
          </div>
          <div style={{flexGrow:1, position:'relative'}} className='d-flex bg-white'>
              <div ref={chatBoxRef} style={{flexGrow:1, overflowY:'scroll', maxHeight:'50vh', paddingBottom:80, paddingTop:10, paddingInline:10}}>
                {chat.map((message, index)=>(
                  <Message key={index} user={message.FullName} content={message.Content}/>
                ))}
              </div>
              <div className='w-100 p-2 bg-white' style={{position:'absolute', bottom:0}}>
                  <div className='d-flex'>
                      <input onChange={handleMessageChange} value={message} className='form-control shadow-none' placeholder='Enter Message'/>
                      <button onClick={sendMessage} className='btn ms-1 btn-success shadow-none'><i className="bi bi-send"></i></button>
                  </div>
              </div>
          </div>
        </div> 
        : 
        <div className='d-flex justify-content-center align-items-center flex-column' style={{height:'100vh'}}>
          <i style={{fontSize:60}} className="bi bi-exclamation-triangle-fill text-danger"></i>
          <p className='d-block text-danger'>{errorMessage}</p>
          <button onClick={handleGoToHome} className='btn btn-dark'>Go To Home</button>
        </div>
      }


      <ToastContainer/>
      <Modal show={show} onHide={()=>setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Seat Request</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-2'>
        {requests.length > 0 ? (
            requests.map((row, index) => (
              <div className="rounded py-1 px-2 border shadow-sm mb-2" key={index}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {index + 1}. <span style={{ fontSize: 14 }}>{row.FullName}</span>
                  </div>
                  <div className="d-flex" style={{ fontSize: 30 }}>
                    <div
                      onClick={() => acceptRequest(row.ID, row.UserID, true)}
                      className="text-success me-2"
                    >
                      <i className="bi bi-check-circle-fill"></i>
                    </div>
                    <div
                      onClick={() => handleRequestAction(row.ID, row.UserID, false)}
                      className="text-danger"
                    >
                      <i className="bi bi-x-circle-fill"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-2">No requests available</div>
          )}
        </Modal.Body>
      </Modal>


      <Modal show={showParticipate} onHide={()=>setShowParticipate(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Live Members</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-2'>
          
          {liveMembers.map((row, index)=>(
            <div className='py-1 px-2 border-bottom' key={index}>
              <div className='d-flex justify-content-start align-items-center'>
                  <div className='rounded-circle border me-2'>
                    <img style={{width:30}} className="img-fluid rounded-circle" src={(row?.ProfilePhoto) ? `data:image/jpeg;base64,${row?.ProfilePhoto}` : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}/>
                  </div>
                  <div>
                    <div className='text-dark' style={{fontSize:14}}>{row.FullName}</div>
                    <div className='text-dark' style={{fontSize:10}}>{row?.City}, {row?.State}</div>
                  </div>
              </div>
            </div>
          ))}
        </Modal.Body>
      </Modal>


      <Offcanvas className='rounded-top h-auto' show={showConfirm} onHide={() => setShowConfirm(false)} placement="bottom">
        <Offcanvas.Header className=' border-bottom'>
          <Offcanvas.Title className='text-center w-100'>Confirm End Call</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <>
            <button onClick={() => handleEndCall(globalUser?.isHost, "END_CALL")} className='btn btn-danger w-100 mb-3 shadow-none'>
            <i className="bi bi-telephone-fill me-2"></i>End Your Call
            </button>
            <button onClick={() => handleEndCall(globalUser?.isHost, "END_METTING")} className='btn btn-danger w-100 mb-1 shadow-none'>
            <i className="bi bi-telephone-fill me-2"></i> End Metting
            </button>
          </>
        </Offcanvas.Body>
      </Offcanvas>
    </>
    );
  })

export default Home